export enum TenRule {
  TwoTensDouble,
  TensDouble,
  TenAgain
}
